export var isWindowExist = function isWindowExist() {
  return typeof window !== 'undefined';
};
export var isProdENV = function isProdENV() {
  return process.env.NODE_ENV === 'production' && process.env.RUN_ENV !== 'server';
};
export var getEnvCookieName = function getEnvCookieName(name) {
  var cookieName = name.toLowerCase();
  if (cookieName.startsWith('prodlike')) return 'prodlike';
  if (cookieName.startsWith('uat')) {
    var regex = /^([A-Za-z]{3}\d+)/;
    var match = cookieName.match(regex);
    return match ? match[1] : '';
  }
  return '';
};
export var getCurrentEnvCookie = function getCurrentEnvCookie() {
  if (!isWindowExist()) return undefined;
  var currentCookie = document.cookie.split('; ').find(function (c) {
    var cookie = c.toLowerCase();
    if (cookie.startsWith('prodlike') || cookie.startsWith('uat')) return cookie;
    return '';
  });
  return currentCookie ? getEnvCookieName(currentCookie) : undefined;
};
export var isLocalhost = function isLocalhost() {
  return isWindowExist() && window.location.href.includes('localhost');
};
export var isProductionOnlyEnv = function isProductionOnlyEnv() {
  return isProdENV();
};